import { render, staticRenderFns } from "./SituacaoContrato.vue?vue&type=template&id=68360eac"
import script from "./SituacaoContrato.vue?vue&type=script&lang=ts"
export * from "./SituacaoContrato.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports